const ANONYMOUS_USER_ID_KEY = 'keiai___anon_user_id';
const MY_KI_USER_ID_KEY = 'keiai___my_ki_user_id';

export default {
  data() {
    return {
      id: null,
    };
  },
  mounted() {
    // 初期化
    this.id = localStorage.getItem(ANONYMOUS_USER_ID_KEY);
  },
  methods: {
    // common
    setUserStorage(id) {
      this.id = id;
      localStorage.setItem(ANONYMOUS_USER_ID_KEY, this.id);
    },
    setKiUserId(id) {
      localStorage.setItem(MY_KI_USER_ID_KEY, id);
    },
    getUserStorage() {
      this.id = localStorage.getItem(ANONYMOUS_USER_ID_KEY);
      return this.id;
    },
    getKiUserId() {
      return localStorage.getItem(MY_KI_USER_ID_KEY);
    },
    clearUserStorage() {
      localStorage.setItem(ANONYMOUS_USER_ID_KEY, '');
      this.id = '';
    },
    clearKiUserId() {
      localStorage.setItem(MY_KI_USER_ID_KEY, '');
    },
  },
};
